import React, { useContext } from "react";
import Profile from "../Profile";
import ErrorBoundary from "../ErrorBoundary";
import { GlobalContext } from "components/AppProvider";
import Notification from "components/Notification";
import { MobileTemplateProps } from "./MobileTemplate.props";
import "./style.scss";

const MobileTemplate = React.memo<MobileTemplateProps>(
    ({ children, withoutBackground, customBody, title }) => {
        const [states] = useContext(GlobalContext);
        const { showNotification } = states;

        return (
            <>
                <div
                    className={`w-100 ${
                        withoutBackground ? "" : "mobile-template"
                    }`}
                >
                    <div className="template-header">
                        <div className="kitchen-icon">{title}</div>
                        {showNotification && <Notification />}
                        <Profile />
                    </div>
                    <div className={`p-4 template-body ${customBody || ""}`}>
                        <ErrorBoundary>{children}</ErrorBoundary>
                    </div>
                </div>
            </>
        );
    }
);

export default MobileTemplate;
